import _, { union, compose, partial, pluck, property } from 'underscore';
import { edmCampaign } from '@bingads-webui/edm-campaign';
import { Campaign } from '@bingads-webui-campaign/campaign-ui-schemas';

const maxAssetGroupsPerCampaign = Campaign.properties.AssetGroups.maxItems;

export const fetchAssetGroupsData = ({
  cid,
  aid,
  campaignId,
  params,
  payload,
}) => edmCampaign
  .Customers.$withKey(cid)
  .Accounts.$withKey(aid)
  .Campaigns.$withKey(campaignId)
  .AssetGroups['Default.GridData']
  .$makeCall({
    query: {
      count: true,
      filter: { where: params.$filter },
      orderby: params.$orderby,
      select: union(params.$select, params.$expand),
      skip: params.$skip || 0,
      top: params.$top || 20,
    },
    payload,
  })
  .toPromise();

export const getAssetGroupsEDM = ({
  cid,
  aid,
  campaignId,
}) => edmCampaign
  .Customers.$withKey(cid)
  .Accounts.$withKey(aid)
  .Campaigns.$withKey(campaignId)
  .AssetGroups['Default.GridData'];

export const getAssetGroupsForCampaign = ({ options: { cid, aid }, parentId: campaignId }) =>
  fetchAssetGroupsData({
    cid,
    aid,
    campaignId,
    params: {
      $select: 'Id',
      $top: maxAssetGroupsPerCampaign,
      $filter: {
        DeliveryStatus: {
          $in: ["Enum.DeliveryStatus'EditorialRejected'", "Enum.DeliveryStatus'EditorialApprovedLimited'"],
        },
      },
    },
  }).then(compose(partial(pluck, _, 'Id'), property('value')));

export const getEditorialReasonsForAssetGroup = ({ options: { cid, aid }, parentId: campaignId, ids }) =>
  edmCampaign
    .Customers.$withKey(cid)
    .Accounts.$withKey(aid)
    .Campaigns.$withKey(campaignId)
    .AssetGroups['Default.GetEditorialReasons']
    .$makeCall({
      functionParams: {},
      payload: {
        EntityIds: ids,
      },
    })
    .toPromise();

export const requestAppealByIDsForParentEntity = ({ options: { cid, aid }, parentId: campaignId }, appealData, appealIds) =>
  edmCampaign
    .Customers.$withKey(cid)
    .Accounts.$withKey(aid)
    .Campaigns.$withKey(campaignId)
    .AssetGroups['Default.CreateAppeals']
    .$makeCall({
      functionParams: {},
      payload: {
        EntityIds: appealIds,
        JustificationText: appealData.Justification,
      },
    })
    .toPromise();

export const requestAppealAllForParentEntity = (options, appealData) =>
  requestAppealByIDsForParentEntity(options, appealData, null);
